import MoveTo from 'moveto';

function moveTo(target, tolarence) {
  const moveToElement = new MoveTo({
    tolerance: tolarence,
  });

  moveToElement.move(target);
}

export { moveTo as default };
